import { render, staticRenderFns } from "./Vouchers.vue?vue&type=template&id=0bb7f50a&scoped=true"
import script from "./Vouchers.vue?vue&type=script&lang=js"
export * from "./Vouchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb7f50a",
  null
  
)

export default component.exports